<template>
    <div class="new-message">
        <form @submit.prevent = "addMessage">
            <label for="new-message">New message (press enter to submit)</label>
            <p v-if="feedback" class="red-text">{{ feedback }}</p>
            <input type="text" v-model="newMessage">
        </form>
    </div>
</template>

<script>
import db from '@/firebase/init'
export default {
    name: 'NewMessage',
    props: ['name'],
    data() {
        return {
            newMessage: null,
            feedback: null
        }
    },
    methods: {
        addMessage() {
            if(this.newMessage) {
                db.collection('messages').add({
                    content: this.newMessage,
                    timestamp: Date.now(),
                    name: this.name
                }).catch(error => {
                    console.log(error)
                 })
                this.newMessage = null,
                this.feedback = null
            } else {
                this.feedback = "You must enter a message in order to send one"
            }
           
        }
    }

}
</script>




// WEBPACK FOOTER //
// src/components/NewMessage.vue